module.exports = __webpack_public_path__ + "img/m1-screenshot-06_t.d3ff40cc.jpg";